// Trwały nośnik tokenu tożsamości koszyka.
//
// Po co: tożsamość koszyka wisi dziś WYŁĄCZNIE na szyfrowanym cookie sesji PS. Gdy
// to cookie zniknie albo nie zdekoduje się (in-app browser Facebooka/Instagrama,
// SameSite, cookie z innej generacji deployu), backend widzi świeżą pustą sesję i
// zwraca pusty koszyk — objaw „wchodzę do koszyka, a koszyk zniknął". Backend
// wystawia więc podpisany HMAC token (`cart_token`), a my trzymamy go poza cookie
// i odsyłamy nagłówkiem X-Cart-Id jako drugą, niezależną ścieżkę ustalenia koszyka.
//
// Świadome decyzje:
//  * localStorage, nie cookie — cookie jest właśnie tym, co zawodzi.
//  * pamięć modułowa jako fallback — w trybie prywatnym / z zablokowanym storage
//    localStorage rzuca; token działa wtedy przynajmniej w obrębie sesji karty.
//  * czyszczenie po złożeniu zamówienia — koszyk zamieniony w zamówienie jest
//    zamknięty, a backend i tak odmówi jego adopcji (patrz CartTokenAdoption).
//
// To leaf-moduł: nie importuje warstwy zapytań, więc nadaje się do testów w node env.

const STORAGE_KEY = 'lavmag.cart_token'

// Fallback na wypadek niedostępnego localStorage (tryb prywatny, blokada storage).
let inMemoryToken = ''

function readStorage(): string {
  try {
    return globalThis.localStorage?.getItem(STORAGE_KEY) ?? ''
  }
  catch {
    return ''
  }
}

function writeStorage(token: string): void {
  try {
    globalThis.localStorage?.setItem(STORAGE_KEY, token)
  }
  catch {
    // Świadomie ignorowane — zostaje pamięć modułowa.
  }
}

function removeStorage(): void {
  try {
    globalThis.localStorage?.removeItem(STORAGE_KEY)
  }
  catch {
    // Świadomie ignorowane.
  }
}

/** Token do odesłania backendowi. '' gdy nie mamy żadnego. */
export function getCartIdentityToken(): string {
  return inMemoryToken || readStorage()
}

/**
 * Utrwala token wystawiony przez backend. Puste wartości są IGNOROWANE — backend
 * pomija `cart_token` np. gdy nie ma sekretu, a odpowiedź z pustym tokenem nie może
 * skasować dobrego, wcześniej zapisanego tokenu.
 */
export function setCartIdentityToken(token: unknown): void {
  if (typeof token !== 'string') {
    return
  }

  const trimmed = token.trim()
  if (!trimmed) {
    return
  }

  inMemoryToken = trimmed
  writeStorage(trimmed)
}

/** Zrzuca token — po złożeniu zamówienia i po wylogowaniu. */
export function clearCartIdentityToken(): void {
  inMemoryToken = ''
  removeStorage()
}

/**
 * Nagłówki identyfikujące koszyk, dokładane do żądań koszyka. Pusty obiekt, gdy nie
 * mamy tokenu — wtedy zachowanie jest dokładnie takie jak dotychczas (samo cookie).
 */
export function cartIdentityHeaders(): Record<string, string> {
  const token = getCartIdentityToken()

  return token ? { 'x-cart-id': token } : {}
}
